import { MergeSchemaData } from '../model/merge.schema.data';
import { MergeSchemaSource } from '../model/merge.schema.source';

export function getMergeSchema(target: MergeSchemaSource): MergeSchemaData {

    if (!target.__meta__) {
        target.__meta__ = {
            name: null,
            displayName: null,
            fields: []
        } as MergeSchemaData;
    }

    return target.__meta__;
}

export function getSchema(target: any): MergeSchemaData {
    return getMergeSchema(target.prototype);
}
